module.exports = __webpack_public_path__ + "img/thumbnail-kojin-dev.50290484.png";